import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import DivContainerBody from '../../../../../components/DivContainerBody';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import {
    CompletePersonChip,
    DocumentLinesIcon,
    DocumentMedalIcon,
    EmailSubsectionChip,
    IconBuildingTable,
    IconClockTable,
    IconDocumentCheck,
    IconScheduleTable,
    IconShoppingCar,
    IconVehicle,
    MobileIcon,
    OutlinedCalendarIcon,
    PersonBook,
    PersonChipBlack,
    UpdateIconsOptions,
    VehicleChip,
} from '../../../../../components/buttons/IconButtons';
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    getDateFormat,
    getModelSimpleSearch,
    userListToLabelEmailPhoneValue,
    vehicleListToLabel,
} from '../../../../../Apis/functions';
import CustomDateTimePicker from '../../../../../components/CustomDateTimePicker';
import { CompleteOrderApp } from '../../Functionality/CompleteOrderApp';
import { status, STATUS_MODEL } from '../../../../../enums/statusEnum';
import CustomAddChipSearch from '../../../../../components/CustomAddChipSearch';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';
import CustomTooltip from '../../../../../components/CustomTooltip';
import CustomCard from '../../../../../components/CustomCard';
import CustomChip from '../../../../../components/CustomChip';
import CustomGenericTittleIconDataChip from '../../../../../components/CustomGenericTittleIconDataChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../../enums/statusColorEnum';
import { SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { TABLES } from './../../../../../Apis/Tables';
import NotInformation from '../../../../../components/NotInformation';
import { VIEW_TYPE } from '../../../../../enums/ViewType';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @param isUpdateOrder
 * @returns {JSX.Element}
 * @constructor
 */
const CompleteOrder = ({ isUpdateOrder }) => {
    const {
        t,
        handelCompleteOrder,
        getOrderDetails,
        estimatedTimeOfArrivalDate,
        handleEstimatedTimeOfArrivalDateChange,
        emptyFields,
        selectedList,
        setSelectedList,
        selectedListVehicle,
        setSelectedListVehicle,
    } = CompleteOrderApp({ isUpdateOrder });

    return (
        <>
            <HeadTittle
                onBack={routes.suppliers.orders}
                name={
                    isUpdateOrder
                        ? t('update')
                        : t('complete')
                          ? getOrderDetails.status?.id === STATUS_MODEL.ORDER_INCOMING
                              ? t('complete')
                              : t('update')
                          : t('complete')
                }
            >
                <ButtonAction
                    id='btn_d_add'
                    name={isUpdateOrder ? t('update') : t('complete')}
                    className='btn-icon-add'
                    Icon={isUpdateOrder ? UpdateIconsOptions : IconDocumentCheck}
                    onClick={() => {
                        handelCompleteOrder();
                    }}
                />
            </HeadTittle>

            <DivContainerBody>
             
                    <div className='row px-0 h-100'>
                        <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0'>
                            <CustomCard classes={'h-100'} classCard={'card-border-8px'} classContent={'p-0'}>
                                <div className='d-flex flex-wrap justify-content-between align-items-center m-3 '>
                                    <CustomGenericTittleIconDataChip
                                        title={'purchase_orders_details'}
                                        Icon={DocumentLinesIcon}
                                        border={false}
                                        classNameTittleContainer={'mb-0'}
                                        titleBoxClass={'d-flex'}
                    
                                    />
                                    <CustomChip
                                        className={'col-4'}
                                        variant={'large'}
                                        background={statusColor[getOrderDetails?.status?.id]}
                                        fontColor={statusFontColor[getOrderDetails?.status?.id]}
                                        borderColor={statusBorderColor[getOrderDetails?.status?.id]}
                                        legend={t(status[getOrderDetails?.status?.id]) || EMPTY_VALUES.DEFAULT}
                                    />
                                </div>{' '}
                                <div className={'border-bottom-shades-300'} />
                                <div className='row align-items-start p-3 overflow-y-auto'>
                                    <div className='col-2 p-0'>
                                        <div className='p-8px border-radius-8px d-flex w-44px h-44px justify-content-center background-secondary-100 mt-4'>
                                            <DocumentMedalIcon className='btn-icon-svg-24px' />
                                        </div>
                                    </div>
                                    <div className='col-10'>
                                        <div className='row my-4 px-0 ml-0 pl-0'>
                                            <div className='pl-0 ml-0'>
                                                <CustomTooltip
                                                    text={getOrderDetails?.folio?.toUpperCase() || EMPTY_VALUES.DEFAULT}
                                                    classes={`ffs-14px font-color-general-950 text-ellipsis-1-row ibl-font-w-600 pl-0 ml-0`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                            <div className='col-12 px-0'>
                                                <div className='d-flex align-items-center'>
                                                    <IconBuildingTable />
                                                    <CustomTooltip
                                                        text={getOrderDetails?.supplier?.acronym}
                                                        classes={'font-color-general-950 fs-14px ml-2'}
                                                        showIfTruncated={true}
                                                        placement={'top'}
                                                    />
                                                </div>
                                            </div>
                                            <div className='border-bottom-shades-300 mt-3' />
                                            <div className='col-12 px-0'>
                                                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 my-3'>
                                                    {t('supplier_information')}
                                                </p>
                                                <div className={'flex-grow-1 minw-0'}>
                                                    <CustomTooltip
                                                        text={getOrderDetails?.supplier?.user?.fullName}
                                                        classes={`fs-14px font-color-general-950 text-ellipsis-1-row px-0 mt-3 mb-1`}
                                                        showIfTruncated={true}
                                                    />
                                                </div>
                                                <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                                    <div className={'d-flex flex-grow-1 minw-0 align-items-center'}>
                                                        <div className={'mr-2 d-flex align-items-center'}>
                                                            <EmailSubsectionChip />
                                                        </div>
                                                        <div className={'flex-grow-1 minw-0'}>
                                                            <CustomTooltip
                                                                text={getOrderDetails?.supplier?.user?.email}
                                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row align-items-center`}
                                                                showIfTruncated={true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={'d-flex flex-grow-1 minw-0'}>
                                                        <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                            <MobileIcon className='icon-color-shades-800 flex-shrink-0' />
                                                        </div>
                                                        <div className={'flex-grow-1 minw-0'}>
                                                            <CustomTooltip
                                                                text={getOrderDetails?.supplier?.user?.phoneNumber}
                                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                                showIfTruncated={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='border-bottom-shades-300 mt-3' />
                                            <div className='col-12 px-0'>
                                                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 my-3'>
                                                    {t('item')}
                                                </p>
                                                <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                                    <div className={'d-flex flex-grow-1 minw-0'}>
                                                        <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                            <IconShoppingCar className='icon-color-shades-800 flex-shrink-0' />
                                                        </div>
                                                        <div className={'flex-grow-1 minw-0'}>
                                                            <CustomTooltip
                                                                text={getOrderDetails?.item}
                                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                                showIfTruncated={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='border-bottom-shades-300 mt-3' />
                                            <div className='col-12 px-0'>
                                                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 my-3'>
                                                    {t('estimated_delivery_date')}
                                                </p>
                                                <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                                    <div className={'d-flex flex-grow-1 minw-0'}>
                                                        <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                            <IconScheduleTable className='icon-color-shades-800 flex-shrink-0' />
                                                        </div>
                                                        <div className={'flex-grow-1 minw-0'}>
                                                            <CustomTooltip
                                                                text={getDateFormat(
                                                                    getOrderDetails?.deliveryDate,
                                                                    false,
                                                                    DATE_TIME_FORMAT_NAME_MODEL.dayWithShortMonth,
                                                                )}
                                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                                showIfTruncated={true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={'d-flex flex-grow-1 minw-0'}>
                                                        <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                            <IconClockTable className='icon-color-shades-800 flex-shrink-0' />
                                                        </div>
                                                        <div className={'flex-grow-1 minw-0'}>
                                                            <CustomTooltip
                                                                text={getDateFormat(
                                                                    getOrderDetails?.deliveryDate,
                                                                    false,
                                                                    DATE_TIME_FORMAT_NAME_MODEL.time12Uppercase,
                                                                )}
                                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                                showIfTruncated={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='border-bottom-shades-300 mt-3' />
                                            <div className='col-12 px-0 gap-2 mt-3'>
                                                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>
                                                    {t('order_description')}
                                                </p>
                                                <p className='font-color-general-950 fs-14px px-0'>
                                                    {getOrderDetails?.description || EMPTY_VALUES.DEFAULT}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CustomCard>
                        </div>
                        <div className='col-12 col-md-8'>
                            <CustomCard classes={'h-100'} classCard={'card-border-8px'} classContent={'p-0'}>
                                <div className='d-flex justify-content-between align-items-center m-3'>
                                    <CustomGenericTittleIconDataChip
                                        title={'delivery_entrance'}
                                        Icon={PersonBook}
                                        border={false}
                                        classNameTittleContainer={'mb-0'}
                                        titleBoxClass={'d-flex'}
                                    />
                                </div>
                           <div className={'border-bottom-shades-300 mb-3'} />
                                    <div className={'col-12 p-0 m-0'}>
                                        <CustomCard
                                            classes={'mb-3 mx-0'}
                                            classCard={'card-border-8px m-3'}
                                            classContent={'p-0 row'}
                                        >
                                            <div className={'d-flex align-items-center my-3'}>
                                                <CustomGenericTittleIconDataChip
                                                    title={t('delivery_date')}
                                                    Icon={OutlinedCalendarIcon}
                                                    border={false}
                                                    classNameTittleContainer={'mb-0'}
                                                    titleBoxClass={'d-flex'}
                                                />
                                            </div>
                                            <div className={'border-bottom-shades-300 mb-3'} />

                                            <div className='mt-3'>
                                                <CustomDateTimePicker
                                                    id='dtp_co_estimated_time_of_arrival'
                                                    name={'estimatedTimeOfArrival'}
                                                    trans={'estimated_time_of_arrival'}
                                                    value={estimatedTimeOfArrivalDate}
                                                    openTo={'year'}
                                                    onChange={handleEstimatedTimeOfArrivalDateChange}
                                                    emptyFields={emptyFields}
                                                    required={true}
                                                    disablePast
                                                    allowSameDateSelection
                                                    ampm={false}
                                                />
                                            </div>
                                        </CustomCard>
                                    </div>
                                    <div className='row'>
                                        <div className={'col-6 pr-0 m-0'}>
                                            <CustomCard
                                                classes={'mb-2'}
                                                classCard={'card-border-8px'}
                                                classContent={'p-0 row mb-3'}
                                            >
                                                <div className={'d-flex align-items-center my-3'}>
                                                    <CustomGenericTittleIconDataChip
                                                        title={t('assigned_employee')}
                                                        Icon={CompletePersonChip}
                                                        border={false}
                                                        classNameTittleContainer={'mb-0'}
                                                        titleBoxClass={'d-flex'}
                                                    />
                                                </div>
                                                <div className={'border-bottom-shades-300 mb-3'} />
                                                <div>
                                                    <CustomAddChipSearch
                                                        autocompleteId={'slt_co_assign_employees'}
                                                        buttonId={'btn_co_assign_employees'}
                                                        selectedList={selectedList}
                                                        setSelectedList={setSelectedList}
                                                        userTypeIdsSearch={[USER_TYPE_MODEL.SUPPLIER_EMPLOYEE]}
                                                        disabled={false}
                                                        label='employee'
                                                        emptyFields={emptyFields}
                                                        required={true}
                                                        reset={false}
                                                        hideButton={true}
                                                        keyId={'userId'}
                                                        showRenderOption={true}
                                                        maxLength={1}
                                                        showSubSection={true}
                                                        sanitizeDataList={userListToLabelEmailPhoneValue}
                                                        Icon={PersonChipBlack}
                                                    />
                                                    {selectedList?.length === 0 && (
                                                        <div className='h-50 '>
                                                            <NotInformation
                                                                card={true}
                                                                text={t('no_employee_selected')}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </CustomCard>
                                        </div>
                                        <div className={'col-6 pl-0 m-0'}>
                                            <CustomCard
                                                classes={'mb-2'}
                                                classCard={'card-border-8px ml-3'}
                                                classContent={'p-0 row mb-3'}
                                            >
                                                <div className={'d-flex align-items-center my-3'}>
                                                    <CustomGenericTittleIconDataChip
                                                        title={t('assigned_vehicle')}
                                                        Icon={IconVehicle}
                                                        border={false}
                                                        classNameTittleContainer={'mb-0'}
                                                        titleBoxClass={'d-flex'}
                                                    />
                                                </div>
                                                <div className={'border-bottom-shades-300 mb-3'} />
                                                <div>
                                                    <CustomAddChipSearch
                                                        autocompleteId='slt_co_vehicle'
                                                        label='vehicle'
                                                        api={SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER}
                                                        model={TABLES.SUPPLIER_VEHICLE}
                                                        selectedList={selectedListVehicle}
                                                        setSelectedList={setSelectedListVehicle}
                                                        reset={false}
                                                        hideButton={true}
                                                        showRenderOption={true}
                                                        showSubSection={true}
                                                        emptyFields={emptyFields}
                                                        required={true}
                                                        maxLength={1}
                                                        bodyApi={getModelSimpleSearch(
                                                            TABLES.SUPPLIER_VEHICLE,
                                                            {
                                                                userId: getOrderDetails?.supplier?.id,
                                                                viewType: VIEW_TYPE.LIST.viewType,
                                                            },
                                                        )}
                                                        sanitizeDataList={(list) =>
                                                        vehicleListToLabel(list, 'id', true, (props) => (
                                                            <VehicleChip
                                                                {...props}
                                                                className='icon-color-general-950'
                                                            />
                                                        ))
                                                        }
                                                        Icon={(props) => (
                                                            <VehicleChip {...props} className='icon-color-general-950' />
                                                        )}
                                                    />
                                                    {selectedListVehicle?.length === 0 && (
                                                        <NotInformation card={true} text={t('no_vehicle_selected')} />
                                                    )}
                                                </div>
                                            </CustomCard>
                                        </div>
                                    </div>
                                </CustomCard>
                          
                        </div>
                    </div>
             
            </DivContainerBody>
        </>
    );
};

export default CompleteOrder;
